import React, { createContext, useState } from "react";
import { NO_KNOWLEDGE_FILTER, toMaxKnowledge } from "../constants/knowledgeFilter";

export const FilterContext = createContext();

// The experience ("knowledge") filter. sessionStorage keeps the chosen level
// for the tab, so it survives a refresh. The API applies it: every tree, search
// and matrix call sends `maxKnowledge` (null when no filter is set).
const readStoredKnowledgeFilter = () => {
    try {
        const stored = sessionStorage.getItem('knowledgeFilter');
        return stored ? JSON.parse(stored) : NO_KNOWLEDGE_FILTER;
    } catch (e) {
        return NO_KNOWLEDGE_FILTER;
    }
};

export const FilterProvider = ({children}) => {
    const [knowledgeFilter, setKnowledgeFilter] = useState(readStoredKnowledgeFilter);

    const applyKnowledgeFilter = (filterSelected) => {
        try {
            sessionStorage.setItem('knowledgeFilter', JSON.stringify(filterSelected));
        } catch (e) {
            // Not persisted; the filter still applies for this page view
        }
        setKnowledgeFilter(filterSelected);
    }

    return (
        <FilterContext.Provider value={{ applyKnowledgeFilter, knowledgeFilter, maxKnowledge: toMaxKnowledge(knowledgeFilter) }}>
            {children}
        </FilterContext.Provider>
    );

}
